/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { useEffect, useMemo, useState } from "react";
import { companies, jobId, users } from "@/services/global.services";
import { useToast } from "@/hooks/use-toast";
import { getJobId } from "@/lib/utils";

export const useMutations = () => {
  const API_SERVICE = useMemo(() => {
    return users;
  }, [companies]);

  const { user_id, company_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [profileData, setProfileData] = useState<any>([]);
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [activeRecordData, setActiveRecordData] = useState(undefined);
  const [tableColumn, setTableColumn] = useState([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const { toast } = useToast();
  const [searchDebounced] = useDebouncedValue(search, 200);

  const { onDelete, status, identity, id, clearDelete } = useDeletePopup();

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 100,
    totalItem: 1,
  });

  //On Load Component
  useEffect(() => {
    setProcess(true);
    (async () => {
      await loadingUsers();
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
  }, []);

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      alert(JSON.stringify(id));
      clearDelete();
    }
  }, [status]);

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        await loadingUsers();
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingUsers();
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingUsers();
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({ action, data }: any) => {
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "delete") {
      setActiveRecordData(data);

      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this profile?",
      });
      await loadingUsers();
    }
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
    }
  }, [formPopupOpen]);

  const loadingUsers = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.get,
      "post",
      payload
    );

    if (data) {
      setProfileData(data.result.metadata[API_SERVICE.key][0]);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  // const getJobId = async (prop: string) => {
  //   const { data, error, message } = await apiServices<any>(
  //     jobId.get + prop,
  //     "get"
  //   );

  //   if (data?.process_status === "in-progress") {
  //     const jobResponse: any = await getJobId(prop);
  //     return jobResponse;
  //   }
  //   if (data?.status?.error_details?.fail_message) {
  //     toast({
  //       title: "Error",
  //       variant: "destructive",
  //       description: data.status.error_details.fail_message,
  //     });
  //     return { data: null, error: true };
  //   }
  //   if (error) {
  //     toast({
  //       title: "Error",
  //       variant: "destructive",
  //       description: error.status?.message || message,
  //     });
  //   }
  //   return { data, error };
  // };

  const onFormSubmit = async (prop: any): Promise<any> => {
    const payload = {
      data: {
        company_id: profileData.company_id,
        company_name: profileData.company_name,
        country: prop.country,
        email: prop.email,
        phone: prop.phone,
        user_id: profileData.user_id,
      },
      company_id: profileData.company_id,
      user_id: user_id,
    };

    const { data, error } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload
    );

    if (data?.job_id) {
      const jobIdResponse = await getJobId(data.job_id);
      if (jobIdResponse.error) {
        return jobIdResponse;
      }
      const getResponse = await loadingUsers();
      if (getResponse.error) {
        return getResponse;
      }
    }

    if (error) {
      setProcess(false);
    }
    return { data, error };
  };

  return {
    skeltonLoading,
    profileData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
  };
};
